define("settings/routes/overview", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/routing/route", "@ember/service", "ember-concurrency", "rsvp", "later/utils/promise-hash"], function (_exports, _asyncArrowRuntime, _route, _service, _emberConcurrency, _rsvp, _promiseHash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/routing/route",0,"@ember/service",0,"ember-concurrency",0,"rsvp",0,"later/utils/promise-hash"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let OverviewRoute = _exports.default = (_class = class OverviewRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "segment", _descriptor4, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor5, this);
      _initializerDefineProperty(this, "store", _descriptor6, this);
      _defineProperty(this, "handleAnalyticsEmailToggle", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (instagramProfile) {
          try {
            instagramProfile.toggleProperty('analyticsEmail');
            yield instagramProfile.save();
            this._alertHelper(false, true, !instagramProfile.analyticsEmail, instagramProfile.nickname);
            instagramProfile.analyticsEmail && this._enabledAnalyticsEmailEvent(instagramProfile.nickname);
          } catch (error) {
            yield (0, _emberConcurrency.timeout)(10); // Needed for checkbox-switch to pick up on the change
            instagramProfile.rollbackAttributes();
            this._alertHelper(true, true, instagramProfile.analyticsEmail, instagramProfile.nickname);
          }
        }
      }), null, "handleAnalyticsEmailToggle", null));
      _defineProperty(this, "handleAllAnalyticsEmailsToggle", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (instagramProfiles, isEnabled) {
          try {
            const savingProfiles = instagramProfiles.map(instagramProfile => {
              instagramProfile.set('analyticsEmail', isEnabled ? false : true);
              return instagramProfile.save();
            });
            yield _rsvp.default.all(savingProfiles);
            instagramProfiles.forEach(instagramProfile => {
              instagramProfile.analyticsEmail && this._enabledAnalyticsEmailEvent(instagramProfile.nickname);
            });
            this._alertHelper(false, false, isEnabled);
          } catch (error) {
            yield (0, _emberConcurrency.timeout)(10); // Needed for checkbox-switch to pick up on the change
            instagramProfiles.forEach(instagramProfile => {
              instagramProfile.rollbackAttributes();
            });
            this._alertHelper(true, false, isEnabled);
          }
        }
      }), null, "handleAllAnalyticsEmailsToggle", null));
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get currentUserModel() {
      return this.auth.currentUserModel;
    }
    activate() {
      this.segment.track('viewed-page', {
        page: 'account'
      });
    }
    model(params) {
      const socialProfiles = this.store.findAll('social-profile');
      const instagramProfiles = socialProfiles.then(socialProfiles => socialProfiles.filter(item => item.isInstagram && (item.isBusiness || item.isCreator) && item.belongsTo('account').id() === this.currentAccount.id).sortBy('nickname'));
      if (params.openMobileModal) {
        this.subscriptions.openMobileRedirectModal();
      }
      return (0, _promiseHash.default)({
        account: this.currentAccount,
        user: this.currentUserModel,
        socialProfiles,
        instagramProfiles
      });
    }
    resetController(controller, isExiting, transition) {
      if (isExiting && transition.targetName !== 'error') {
        controller.set('openMobileModal', undefined);
      }
    }
    async canEditKeycloakEmail() {
      if (this.auth.isKeycloak) {
        const response = await this.auth.currentUserModel.ciamInfo(undefined);
        return response.can_user_update_email;
      }
      return false;
    }
    async setupController(controller, _ref) {
      let {
        account,
        user,
        socialProfiles,
        instagramProfiles
      } = _ref;
      controller.setProperties({
        account,
        user,
        socialProfiles,
        instagramProfiles,
        handleAnalyticsEmailToggle: this.handleAnalyticsEmailToggle,
        handleAllAnalyticsEmailsToggle: this.handleAllAnalyticsEmailsToggle
      });
      const canEditKeycloakEmail = await this.canEditKeycloakEmail();
      controller.set('canEditKeycloakEmail', canEditKeycloakEmail);
    }
    _alertHelper(isError, isSingle, isEnabled, nickname) {
      const enableString = !isEnabled ? 'enable' : 'disable';
      const singleString = isSingle ? '' : '_all';
      const config = nickname ? {
        profile: nickname
      } : {};
      const alertMessage = isError ? 'alerts.generic_error_message' : `alerts.account.overview.analytics_emails.success.message_${enableString + singleString}`;
      const alertTitle = this.intl.t(`alerts.account.overview.analytics_emails.${isError ? 'error' : 'success'}.title`);
      this.alerts[isError ? 'warning' : 'success'](this.intl.t(alertMessage, config), {
        title: alertTitle
      });
    }
    _enabledAnalyticsEmailEvent(nickname) {
      this.segment.track('enabled-ig-analytics-email', {
        profile: nickname
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});